import React from 'react';
import { VideoSelfieRecovery } from 'components/VideoSelfieRecovery/VideoSelfieRecovery';
import { formatText } from 'core/i18n';
import { Header } from 'components/header/header';
import { useParams } from 'react-router-dom';

export const VideoSelfieCaptureView = () => {
    const { token, id } = useParams();

    return (
        <>
            <Header title={formatText('videoselfie-title')} hiddenContinueProcess />
            <VideoSelfieRecovery clientId={id} token={token} />
        </>
    );
};
